module.exports = __webpack_public_path__ + "static/productdeve-48da24119f10ed83c8ff67f7b2350751.png";